import { Router } from '@angular/router';
import { Component, Inject, Input, OnInit, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { HomepageService } from '../../../../shared/services/homepage/homepage.service';
import { EventsService } from './../../../../shared/services/events/events.service';
import { UtilService } from './../../../../shared/services/util/util.service';
import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { StorageService } from '../../../../shared/services/storage/storage.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs';
import { environment } from '@environment';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPhoneNumber } from 'firebase/auth';
import { FrCauses } from 'src/app/shared/models/fundraiser-causes';
import { HospitalStatus } from 'src/app/shared/models/hospital-status';
import { FundsUsed } from 'src/app/shared/models/funds-used';
import { LeadQueryTypes } from 'src/app/shared/models/lead-query-types';

@Component({
  selector: 'app-common-talktous-modal',
  templateUrl: './common-talktous-modal.component.html',
  styleUrls: ['./common-talktous-modal.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('150ms ease-in', style({ transform: 'translateY(0%)' }))
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ transform: 'translateY(-100%)' }))
      ])
    ])
  ]
})
export class CommonTalktousModalComponent implements OnInit, OnDestroy {

  @Input() header = true;
  @Input() label = 'Submit';
  @Input() closebtn = true;
  @Input() showSacBtn;
  @Input() showEmail = true;
  @Input() campaignCount;
  @Input() leadQueryType;
  @Input() fundUsed = '';
  @Input() frCause;
  @Input() hideFields;
  @Input() askQuery = true;
  @Input() successPopup = false;
  @Input() isMedicalFinanceLoans = false;
  @Input() leadMailToInput;
  @Input() hideConnectBtn;
  @Output() isFormSubmit = new EventEmitter();

  isSuccess = false;
  name: FormControl;
  email: FormControl;
  mobile: FormControl;
  query_type: FormControl;
  fundusedfor: FormControl;
  hospitalstatus: FormControl;
  query: FormControl;
  leadForm: FormGroup;
  extn: string;
  cause: FormControl;
  captcha: FormControl;
  isMobile: any;
  otpForm: FormGroup;
  isOtpVerified = false;
  otpText = 'Send OTP';
  captchaSubs: Subscription;
  otp: FormControl;
  showOtpInput = false;
  otpSendSuccess = false;
  @ViewChild('leadFormRef') leadFormRef: NgForm;

  checkCountry = true;
  formInfo = {
    'name': {
      'placeholder': 'Name',
      'error': {
        'maxlength': 'Maximum character limit exceeds',
        'pattern': 'Please enter a valid name'
      },
    },
    'email': {
      'placeholder': 'Email Address',
      'error': {
        'email': 'Please enter a valid email',
        'pattern': 'Please enter a valid email'

      },
    },
    otp: {
      placeholder: 'Enter OTP',
      error: {
        required: 'This field is required',
      }
    },
    'query_type': {
      'placeholder': '',
      'error': {
        'email': 'Please Select type of query',
      },
    },
    'query': {
      'placeholder': '',
      'error': {
        'minlength': 'Please enter minimum 4 characters',
        'maxlength': 'The ask a question field may not be greater than 300 characters'
      },
    },
  };
  allCauses;
  @Input() public causes: any[];
  isLoading;
  @ViewChild('successPopupRef', { static: true }) public successPopupRef;
  @ViewChild('captchaRef') captchaRef;
  otpCount = 0;
  isLoadingForOtp = false;
  mobileSubs: Subscription;

  userdata;

  frCauses: any[] = FrCauses;
  hospitalStatusData = HospitalStatus;
  fundsUsed = FundsUsed;
  leadQueryTypesData = LeadQueryTypes;

  constructor(
    private homePageService: HomepageService,
    private eventsService: EventsService,
    private utilService: UtilService,
    public variablesService: VariablesService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private storageService: StorageService,
    private router: Router
  ) { }

  ngOnInit() {
    this.data = { ...this.data };
    this.isMobile = this.utilService.isMobile();
    this.formInit();
    this.getextn();
    this.getMergedCauses();
    this.preFillForm();
    this.isFormSubmit.emit(false);
  }

  preFillForm() {
    this.variablesService.userData.subscribe(
      data => {
        // if (data) {
        //   this.userdata = data;
        //   if (data.extension) {
        //     this.checkCountry = false;
        //   }
        //   this.leadForm.patchValue({
        //     'name': data.full_name,
        //     'mobile': data.extension + data.phone_1,
        //     'email': data.email
        //   });
        // }
      }
    );
  }

  formInit() {
    this.leadForm = new FormGroup({
      name: this.name = new FormControl('', [Validators.required, Validators.pattern(/[a-z.'-]{4,}/i)]),
      email: this.email = new FormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.pattern(this.variablesService.email_Pattern_Regex)
      ]),
      mobile: this.mobile = new FormControl('', [Validators.required]),
      query_type: this.query_type = new FormControl('', [Validators.required]),
      captcha: this.captcha = new FormControl('', [Validators.required])
    });
    this.patchForm();

    this.otpForm = new FormGroup({
      otp: this.otp = new FormControl('', Validators.required)
    });

    this.mobileSubs = this.mobile.valueChanges.subscribe(value => {
      if (value === '' || (value && value.length < 10)) {
        this.isOtpVerified = false;
        this.otpSendSuccess = false;
        if (this.otp.value !== '') {
          this.otp.reset();
          this.otp.markAllAsTouched();
        }
      }
    });
  }

  patchForm() {
    this.leadForm.patchValue({
      query_type: this.leadQueryType || '',
    });
    if (this.frCause) {
      this.leadForm.addControl('cause', this.cause = new FormControl(this.frCause, [Validators.required]));
    }
    if (this.frCause === 'medical') {
      this.leadForm.addControl('status', this.hospitalstatus = new FormControl('', [Validators.required]));
      this.leadForm.addControl('fund', this.fundusedfor = new FormControl(this.fundUsed, [Validators.required]));
    }
    if (this.askQuery) {
      this.leadForm.addControl('query', this.query = new FormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(300)
      ]));
    }
  }

  getextn() {
    this.utilService.number$.subscribe(res => this.extn = res.extn);
  }

  lead(origin?) {
    if (this.variablesService.pageName.match('stories|campaign')) {
      this.eventsService.sendSystemEvent({
        eventName: 'friend_referred',
        info_1: this.userdata?.id || '',
      }).subscribe(_=>_);
    }
    if (this.leadForm.valid && this.otpForm.valid) {
      // tslint:disable-next-line:max-line-length
      let mailTo = this.query_type.value === 'want_to_raise_funds' ? this.variablesService.leadMailTo : this.variablesService.leadMailToInfo;

      if (this.leadMailToInput) {
        this.data.leadMailTo = this.leadMailToInput;
      }
      const urlWithoutParams = this.router.url.split('?')[0];
      if (urlWithoutParams.split('/').includes('medical-fundraising') || urlWithoutParams.split('/').includes('hospital')) {
        mailTo = 'leads1.ketto@gmail.com';
        this.data.leadMailTo = 'leads1.ketto@gmail.com';
      }

      const subj = this.getPageOrigin();

      const leadPayload: any = {
        name: this.name.value,
        email: this.email.value,
        extension: this.extn,
        phone: this.mobile.value,
        about: this.query ? this.query.value : 'This is an empty query',
        query_type: this.query_type.value,
        page: this.variablesService.pageName || 'home',
        type: this.data?.lead_type || this.variablesService.leadType || 'ketto-campaign-lead',
        mail_to: (this.data && this.data.leadMailTo) ? this.data.leadMailTo : mailTo,
        subject: subj + this.variablesService.leadSubject,
        'g-recaptcha-response': this.captcha.value
      };
      this.variablesService.leadType = '';
      if (leadPayload.subject === 'You received a new lead') {
        leadPayload.type = 'P - Talk to us (browse fundraisers)';
      }
      if (this.query_type.value === 'want_to_raise_funds') {
        leadPayload.cause = this.leadForm.get('cause').value;
        leadPayload.city = this.utilService.getCityFromIp();
        Object.assign(leadPayload, this.utilService.getUTMs());
        // leadPayload.mail_to = this.leadForm.get('cause').value === 59 ? environment.zoho_mail_medical : environment.zoho_mail;
      }
      if (this.cause && this.cause.value === 'medical') {
        leadPayload.fundusedfor = this.leadForm.get('fund').value;
        leadPayload.hospitalstatus = this.leadForm.get('status').value;
      }
      this.homePageService.postLeadData(leadPayload).subscribe(
        (res: any) => {
          if (res.error === false) {
            const pageViewPayload = {
              eventName: 'campaign_lead_created',
              event_type: 'campaign',
              info_2: res.data.id,
              info_1: 1,
              page_name: this.variablesService.pageName,
              referrer_page: this.utilService.getReferrer()
            };
            this.eventsService.sendSystemEvent(pageViewPayload).subscribe();
            this.isLoading = false;
            if (origin === 'sac') {
              this.eventsService.userGTMEvents({
                event: 'start_fundraiser',
                event_category: 'cta',
                event_action: 'start a fundraiser',
                event_label: `START A FUNDRAISER|${window.location.href}`
              });
              this.gotoSac(res.data.user_exist);
            }
            if (this.successPopup && origin !== 'sac') {
              this.dialog.open(this.successPopupRef, {
                height: 'auto',
                width: '519px',
                panelClass: 'medical-sac-modal'
              });
            } else {
              this.isFormSubmit.emit(true);
              this.isSuccess = true;
            }
            this.resetForms();
          } else {
            this.isSuccess = false;
            this.resetForms();
          }
        },
        (err) => {
          this.isLoading = false;
          this.resetForms();
          this.utilService.openSnackBar(err.error.message, 'error');
          this.toggleCaptcha();
        }
      );
    } else {
      this.utilService.checkValidForm(this.leadForm);
      this.utilService.checkValidForm(this.otpForm);
      if (this.captcha.invalid) {
        this.toggleCaptcha();
      }
    }
  }

  onQueryTypeSelection() {
    if (this.query_type.value === 'want_to_raise_funds') {
      this.leadForm.addControl('cause', this.cause = new FormControl('', [Validators.required]));
    } else {
      this.leadForm.removeControl('cause');
    }
    this.utilService.checkIntlTelError.next(true);
  }

  onMedicalSelection() {
    if (this.cause.value === 'medical') {
      this.leadForm.addControl('fund', this.fundusedfor = new FormControl('', [Validators.required]));
      this.leadForm.addControl('status', this.hospitalstatus = new FormControl('', [Validators.required]));
    } else {
      this.leadForm.removeControl('fund');
      this.leadForm.removeControl('status');
    }
    this.utilService.checkIntlTelError.next(true);
  }

  getMergedCauses() {
    this.homePageService.getMergedCauses().subscribe((res: any) => {
      const personalCauses = res[0].data.child;
      this.utilService.moveMedicalCauseToTop(personalCauses);
      this.allCauses = res;
    });
  }
  getPageOrigin() {
    switch (this.variablesService.pageName) {
      case 'crowdfunding': {
        this.variablesService.leadType = 'P - Talk to us (How it works)';
        return 'How it works(Talk to Us)-';
      }
      case 'home': {
        this.variablesService.leadType = 'P - Talk to us (homepage).';
        return 'Homepage(Talk to Us)-';
      }
      case 'browse': {
        this.variablesService.leadType = '';
        return 'Browse fundraisers(Talk to Us)-';
      }
      case 'browse_fundraiser': {
        this.variablesService.leadType = '';
        return 'Browse fundraisers(Talk to Us)-';
      }
      case 'medical': {
        this.variablesService.leadType = 'P - Medical Landing Page';
        return 'Medical landing page-';
      }
      case 'thank_you': {
        this.variablesService.leadType = '';
        return 'Thank you(Talk to Us)-';
      }
      case 'stories': {
        this.variablesService.leadType = 'P - Refer a friend';
        return 'StoryPage';
      }
      case 'campaign': {
        this.variablesService.leadType = 'P - Refer a friend';
        return 'FundraiserPage';
      }
      case 'cancer': {
        this.variablesService.leadType = '';
        return 'cancer crowdfunding page-';
      }
      case 'hospital': {
        this.variablesService.leadType = 'P - Hospital Landing Page';
        return 'Hospital landing page-';
      }
      default: {
        this.variablesService.leadType = '';
        return '';
      }
    }
  }

  connectOnWhatsapp() {
    if (typeof window !== 'undefined') {
      window.open('https://api.whatsapp.com/send?phone=91' + this.variablesService.contactUsMobNumber, '_blank');
    }
  }

  gotoSac(user_exist?) {
    if (!this.userdata) {
      this.sendSystemEvent();
      if (user_exist) {
        this.utilService.openSnackBar('You are already registered with us, Please login', 'success');
        this.storageService.checkFromSession('signup-email', this.email.value);
        this.utilService.router.navigate(['/new/signin'], { queryParams: { 'redirect_uri': '/new/crowdfunding/medical' } });
      } else {
        this.utilService.openSnackBar('Please signup to Start a Fundraiser', 'success');
        const campaignerData = {
          'mobile': this.mobile.value,
          'extension': this.extn,
          'name': this.name.value,
          'email': this.email.value
        };
        this.storageService.addSessionData('dockCampaignerData', campaignerData);
        const queryParams = { type: 'medical' };
        if (this.variablesService.pageName === 'hospital') {
          queryParams['hospital'] = 'true';
        }
        this.utilService.router.navigate(['new/crowdfunding'],
          {
            queryParams,
            queryParamsHandling: 'merge'
          }
        );
      }
    } else {
      const queryParams = {};
      if (this.variablesService.pageName === 'hospital') {
        queryParams['hospital'] = 'true';
      }
      this.utilService.router.navigate(['/new/crowdfunding/medical'], {
        queryParams,
        queryParamsHandling: 'merge'
      });
    }
  }
  sendSystemEvent() {
    const payload = {
      'eventName': 'start_a_campaign_initiated',
      'entity_type': 'start_a_campaign_initiated',
      'event_type': 'campaign',
      'info_1': 'type',
      'info_2': 'landingpage_1',
      'page_name': 'medical_fundraising'
    };
    this.eventsService.systemEventPush(payload);
  }

  eventListner(event) {
    this.eventsService.userGTMEvents({
      event: 'chat_click',
      event_category: 'navigation',
      event_action: 'whatsapp chat click',
      event_label: `${event.target.innerText}|body`
    });
  }

  toggleCaptcha() {
    if (this.captchaRef) {
      this.captchaRef.resetCaptcha();
      this.captchaRef.executeCaptcha();
      this.captcha.setValue('');
    }
  }

  recaptchaVerification(): void {
    this.toggleCaptcha();
    this.isLoadingForOtp = true;

    setTimeout(() => {
      this.captchaSubs = this.captchaRef.captchaResolvedObs.subscribe({
        next: (data) => {
          if (data !== null && data !== '') {
            this.captcha.setValue(data);
            this.getOTPValue();
          } else {
            this.isLoadingForOtp = false;
          }
        }
      });
    }, 200);
  }

  getOTPValue(): void {
    if (this.mobile.valid && typeof window !== 'undefined') {
      const appVerifier = (<any>window).recaptchaVerifier;
      const auth = getAuth(initializeApp(environment.firebase));
      signInWithPhoneNumber(auth, this.extn + this.mobile.value, appVerifier).then(result => {
        this.isLoadingForOtp = false;
        this.showOtpInput = true;
        (<any>window).confirmationResult = result;
        this.otpCount += 1;
        this.otpText = this.otpCount >= 1 ? 'Res' : 'S';
        this.otpText += 'end OTP';
        this.utilService.openSnackBar('OTP has been sent to your number ' + this.mobile.value, 'success');
        this.otpSendSuccess = true;
      }).catch(error => {
        this.isLoadingForOtp = false;
        this.utilService.openSnackBar(error.message + ': ' + error.code, 'error');
      });
    }
  }

  verifyUserOTP(origin?): void {
    if (String(this.otp.value) !== '' && this.otpSendSuccess) {
      this.isLoading = true;
      if (typeof window !== 'undefined') {
        (<any>window).confirmationResult.confirm(String(this.otp.value)).then(result => {
          const self = this;
          result.user.getIdToken().then(function (idToken) {
            self.isOtpVerified = true;
            self.lead(origin);
          });
        }).catch(error => {
          this.isOtpVerified = false;
          this.isLoading = false;
          this.otp.markAllAsTouched();
          this.utilService.openSnackBar(error.message, 'error');
          this.captchaRef.resetCaptcha();
        });
      }
    } else if (this.isLoadingForOtp) {
      this.utilService.openSnackBar('Please wait', 'error');
    } else if (!this.otpSendSuccess) {
      this.utilService.openSnackBar('OTP not sent', 'error');
    } else {
      this.showOtpInput = true;
      this.otp.markAllAsTouched();
    }
  }

  ngOnDestroy(): void {
    if (this.captchaSubs) {
      this.captchaSubs.unsubscribe();
    }
  }

  resetForms() {
    this.formInit();
    this.leadFormRef.resetForm();
    this.showOtpInput = false;
  }
}
